import {getSites} from '@/api/sites';
import {useQuery} from '@tanstack/react-query';

export function useSites() {
    return useQuery({
        queryKey: ['sites'],
        queryFn: getSites
    });
}
